import { useCallback } from "react";

import { useReferralStatus } from "@jti/rest-api";
import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import { setReferralStatus } from "@jti/store/slices/loyaltyCoreSlice";

export const useSyncReferralStatus = () => {
  const dispatch = useDispatch();
  const isReferralOn = useSelector((state) => state.loyaltyCore.isReferralOn);

  const syncReferralStatus = useCallback(
    (data: boolean | null) => {
      if (data != null) {
        const referralStatus = Boolean(data);

        if (isReferralOn !== referralStatus) {
          dispatch(setReferralStatus(referralStatus));
        }
      }
    },
    [isReferralOn, dispatch]
  );

  const referralStatusQuery = useReferralStatus({
    onSuccess: syncReferralStatus,
  });

  return referralStatusQuery;
};
